export const BREAKPOINTS = {
  xs: '480px', // Extra small devices
  sm: '768px', // Small devices
  md: '992px', // Medium devices
  lg: '1200px', // Large devices
  xl: '1440px', // Extra large devices
};

export const HEIGHT_BREAKPOINTS = {
  xs: '600px', // Very small height
  sm: '700px', // Small height
  md: '800px', // Medium height
  lg: '900px', // Large height
};
